module.exports = __webpack_public_path__ + "static/media/Quicksand-Bold.47b95d59.woff";